import React from 'react';
import flow from 'lodash/flow';
import AnalyticsData from '@atlassian/jira-analytics-web-react/src/components/analytics-data.tsx';
import { AnalyticsSubject } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import ErrorBoundary from '@atlassian/jira-error-boundary/src/main.tsx';
import Placeholder from '@atlassian/jira-placeholder';
import { connect } from '@atlassian/jira-react-redux';
import { ANALYTIC_CONTEXTS } from '@atlassian/jira-servicedesk-common/src/utils/analytics';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type KnowledgeHubArticleCategoryList from '../knowledge-hub-article-category-list';
import type { ConnectedKnowledgeHubArticleCategoryListProps } from '../knowledge-hub-article-category-list';
import type KnowledgeHubArticleLabelList from '../knowledge-hub-article-label-list';
import type { KnowledgeHubArticleLabelListProps } from '../knowledge-hub-article-label-list';
import KnowledgeHubArticleStateless from './view';

const LazyKnowledgeHubArticleCategoryList = lazyAfterPaint<typeof KnowledgeHubArticleCategoryList>(
	() =>
		import(
			/* webpackChunkName: "knowledge-hub-article-category-list" */ '../knowledge-hub-article-category-list'
		),
);

const KnowledgeHubArticleCategoryListAsync = (
	props: ConnectedKnowledgeHubArticleCategoryListProps,
) => (
	<ErrorBoundary
		id="knowledge-hub-article-category-list"
		packageName="@atlassian/jira-servicedesk-knowledge-hub"
	>
		<Placeholder name="knowledge-hub-article-category-list" fallback={null}>
			<LazyKnowledgeHubArticleCategoryList {...props} />
		</Placeholder>
	</ErrorBoundary>
);

const LazyKnowledgeHubArticleLabelList = lazyAfterPaint<typeof KnowledgeHubArticleLabelList>(
	() =>
		import(
			/* webpackChunkName: "knowledge-hub-article-label-list" */ '../knowledge-hub-article-label-list'
		),
);

const KnowledgeHubArticleLabelListAsync = (props: KnowledgeHubArticleLabelListProps) => (
	<ErrorBoundary
		id="knowledge-hub-article-label-list"
		packageName="@atlassian/jira-servicedesk-knowledge-hub"
	>
		<Placeholder name="knowledge-hub-article-label-list" fallback={null}>
			<LazyKnowledgeHubArticleLabelList {...props} />
		</Placeholder>
	</ErrorBoundary>
);

export default flow(
	AnalyticsData({
		attributes: {
			context: ANALYTIC_CONTEXTS.KNOWLEDGE,
		},
	}),
	AnalyticsSubject('article'),
	// @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
	connect(
		() => ({
			KnowledgeHubArticleCategoryList: KnowledgeHubArticleCategoryListAsync,
			KnowledgeHubArticleLabelList: KnowledgeHubArticleLabelListAsync,
		}),
		{},
	),
)(KnowledgeHubArticleStateless);
